export default {
  Summary: "Summary",
  SPVBankAccount: "SPV Bank Account",
  Calendar: "Calendar",
};
